import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./CreateContract.css";
import Sidebar from "./sidebar";

const CreateContract = () => {
  const [contractNumber, setContractNumber] = useState("");
  const [contractDate, setContractDate] = useState("");
  const [remainingAmount, setRemainingAmount] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [products, setProducts] = useState([{ productName: "", quantity: 0, unit: "", price: 0, total: 0 }]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [clientName, setClientName] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}v1/clients/${id}`)
      .then(response => {
        setClientName(response.data.name);
      })
      .catch(error => {
        console.error("Ошибка при получении данных клиента:", error);
      });
  }, [id]);

  useEffect(() => {
    const calculateTotalAmount = () => {
      const total = products.reduce((acc, product) => acc + parseFloat(product.total || 0), 0);
      setTotalAmount(total);
    };
    calculateTotalAmount();
  }, [products]);

  const handleProductChange = (index, event) => {
    const { name, value } = event.target;
    const updatedProducts = products.map((product, i) => {
      if (i === index) {
        const updatedProduct = { ...product, [name]: value };
        if (name === 'quantity' || name === 'price') {
          const quantity = name === 'quantity' ? value : product.quantity;
          const price = name === 'price' ? value : product.price;
          updatedProduct.total = (quantity * price).toFixed(2);
        }
        return updatedProduct;
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const addProduct = () => {
    setProducts([...products, { productName: "", quantity: 0, unit: "", price: 0, total: 0 }]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_API_URL}v1/contracts`, {
        client_id: id,
        contract_number: contractNumber,
        contract_date: contractDate,
        remaining_amount: remainingAmount,
        start_date: startDate,
        end_date: endDate,
        products: products,
        total_amount: totalAmount
      })
      .then((res) => {
        navigate(`/client-details/${id}`);
      })
      .catch((error) => {
        console.error("Ошибка при создании договора:", error);
      });
  };

  return (
    <div className="main-container-create-contract">
      <div className="sidebar-create-contract">
        <Sidebar />
      </div>
      <div className="content-create-contract">
        <div className="header-create-contract">
          <h2>Создание договора</h2>
          <div className="client-name">Клиент: {clientName}</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Номер договора:</label>
            <input
              type="text"
              value={contractNumber}
              onChange={(e) => setContractNumber(e.target.value)}
              required
            />
          </div>
          
          <div>
            <label>Дата начала:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Дата окончания:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </div>
          <h3>Продукты</h3>
          <table className="product-table">
            <thead>
              <tr>
                <th>Название продукта</th>
                <th>Количество</th>
                <th>Единицы измерения</th>
                <th>Цена</th>
                <th>Общая сумма</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      name="productName"
                      value={product.productName}
                      onChange={(e) => handleProductChange(index, e)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="quantity"
                      value={product.quantity}
                      onChange={(e) => handleProductChange(index, e)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="unit"
                      value={product.unit}
                      onChange={(e) => handleProductChange(index, e)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="price"
                      value={product.price}
                      onChange={(e) => handleProductChange(index, e)}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="total"
                      value={product.total}
                      readOnly
                    />
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="4">Общая сумма:</td>
                <td>{totalAmount.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <button type="button" onClick={addProduct} className="Create-contract-button">Добавить продукт</button>
          <button type="submit" className="Create-contract-button">Создать</button>
        </form>
      </div>
    </div>
  );
};

export default CreateContract;
